import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logo from './images/logo.png';
import NavigationItem from './components/NavigationItem/';
import Cross from './components/Cross/';
import ScrollBar from 'react-scrollbars-custom';
import './style.css';


const logoHeight = 70;
class SideBar extends Component {
  render() {
    const {
      navigationConfig,
      handleToggleSidebar,
      isSmallScreen,
      isSidebarShow,
      isSidebarDisplay,
      companyLogo,
      primaryColor,
      location,
    } = this.props;
    const isOnlyEmployeeRole = navigationConfig.length === 1;
    return (
      <div style={{ display: isSidebarDisplay ? 'block' : 'none' }}>
        {isSmallScreen && (
          <div
            className={`apollo-sidebar-mask ${isSidebarShow ? 'show' : ''}`}
            onClick={handleToggleSidebar}
          />
        )}
        <div
          style={{
            top: isSmallScreen ? 0 : logoHeight,
            position: 'fixed',
            transform: isSidebarShow || !isSmallScreen ? 'translateX(0%)' : 'translateX(-100%)',
            transition: 'transform .3s',
            zIndex: 12,
          }}
        >
          <div className="apollo-sidebar-logo-container">
            <Cross onClick={handleToggleSidebar} />
            <div className="apollo-header-logo">
              <a href="/tube" onClick={this.props.onLinkClick}>
                <img src={companyLogo || logo} />
              </a>
            </div>
          </div>
          <ScrollBar
            className="apollo-sidebar-scrollbar"
            style={{
              height: isSmallScreen ? '100vh' : `calc(100vh - ${logoHeight}px)`,
              width: 280,
              backgroundColor: '#efeff4',
            }}
            trackYProps={{
              style: {
                height: isSmallScreen ? `calc(100% - ${logoHeight + 16}px)` : 'calc(100% - 16px)',
                top: isSmallScreen ? `${logoHeight + 8}px` : '8px',
              },
            }}
            noScrollX
          >
            <ul className="apollo-sidebar-navigation">
              {navigationConfig.map((n, idx) => {
                return (
                  <div key={idx}>
                    {(!isOnlyEmployeeRole && n.title) && <div className="apollo-sidebar-navigation-title">{n.title}</div>}
                    {n.items &&
                      n.items.map((item, itemIdx) => {
                        return (
                          <NavigationItem
                            {...item}
                            location={location}
                            onLinkClick={handleToggleSidebar}
                            key={itemIdx}
                            primaryColor={primaryColor}
                          />
                        );
                      })}
                  </div>
                );
              })}
            </ul>
          </ScrollBar>
        </div>
      </div>
    );
  }
}

SideBar.propTypes = {
  navigationConfig: PropTypes.array,
  location: PropTypes.object,
  handleToggleSidebar: PropTypes.func,
  onLinkClick: PropTypes.func,
  isSmallScreen: PropTypes.bool,
  isSidebarShow: PropTypes.bool,
  isSidebarDisplay: PropTypes.bool,
  companyLogo: PropTypes.string,
  primaryColor: PropTypes.string,
};

export default SideBar;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/SideBar/index.js
 **/